export default __webpack_public_path__ + "static/media/i132vp.e6de5e7a.webp";